import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FLAGS } from 'legacy/common/constants/launchdarkly';
import Redirect from 'legacy/components/util/Redirect/Redirect';
import { useRouter } from 'next/router';

import BigSpenders from 'screens/associations/AssociationAnalytics/TopN/pages/BigSpenders';

const BigSpendersScreen = () => {
  const router = useRouter();
  const { query } = router;
  const associationId = query.associationId as string;
  const flags = useFlags();
  if (!flags[FLAGS.ENABLE_NEW_EVENT_DASHBOARD]) {
    return <Redirect to={`/associations/${associationId}`} />;
  }

  return <BigSpenders />;
};

export default BigSpendersScreen;

BigSpendersScreen.getLayout = (page) => <>{page}</>;
